import React from 'react';
import './projects.css';

import {Project} from '../../components';
import {Wheel, backprop, featureDetection, proj1, proj3, motivationCal, motivationBotDemo, roadSignDemo } from './imports';

const Projects = () => {
  const projectsData = [
    {
      imgUrl: motivationCal,
      date: 'Jan 2026',
      title: 'Goal Tracker & Motivation Calendar',
      url: null,
      video: motivationBotDemo
    },
    {
      imgUrl: proj1,
      date: 'May 2023',
      title: 'Road Sign Detection',
      url: 'https://github.com/Matthew1320/Road-Sign-Detection',
      video: roadSignDemo
    },
    {
      imgUrl: proj3,
      date: 'Jun 2023',
      title: 'Personal Website',
      url: 'https://github.com/Matthew1320/Personal-Website',
      video: null
    },
    {
      imgUrl: featureDetection,
      date: 'Oct 2022',
      title: 'Feature Detection and Matching',
      url: 'https://github.com/Matthew1320/Feature-Detection-Public',
      video: null
    },
    {
      imgUrl: backprop,
      date: 'Sep 2022',
      title: 'Backpropagation Engine',
      url: 'https://github.com/Matthew1320/BackProp-Public/tree/main',
      video: null
    },
    {
      imgUrl: Wheel,
      date: 'Dec 2021',
      title: 'Wheel of Fortune',
      url: 'https://github.com/Matthew1320/Wheel-of-Fortune-Public',
      video: null
    }
  ];

  return (
    <div className='my__projects section__padding' id='projects'>
      <div className='my__projects-heading'>
        <h1 className='gradient__text'>My Projects</h1>
      </div>
      <div className='my__projects-container'>
        {projectsData.map((project, index) => (
          <Project 
            key={index}
            imgUrl={project.imgUrl} 
            date={project.date} 
            title={project.title} 
            url={project.url}
            video={project.video}
          />
        ))}
      </div>
    </div>
  )
}

export default Projects